import React, { Component, Fragment } from 'react'
import styles from './style.module.less'
import { Button, message } from 'hljd'
import { observer } from 'mobx-react'
import store from '../store'
import CopyToClipboard from 'react-copy-to-clipboard'

@observer
export default class extends Component {
  render() {
    const { detail } = store
    let time = detail.created_at && detail.created_at.substring(0, 10)
    let url = `/localMerchant/hoterCashier?title=${time}佣金打款&id=${
      detail.id
    }&status=${detail.status}&price=${detail.commission_fee}`
    let qrcode =
      '/p/wedding/Admin/APIHotelSettleOrder/QrCode?url=' +
      encodeURIComponent(
        window.location.origin + window.location.pathname + '#' + url
      )

    return (
      <div className={styles.box}>
        <div className={styles.left} style={{ width: 575 }}>
          <div className={styles.left} style={{ width: 386 }}>
            <p className={styles.p1}>本期佣金账单已出：</p>
            <p>账单日{time}</p>
            <p className={styles.p2}>
              <span className={styles.inline}>
                订单数：{detail.order_count || 0}{' '}
              </span>
            </p>
          </div>
          <div className={styles.left}>
            <p className={styles.p3}>¥{detail.commission_fee || 0}</p>
            {detail.status == 0 && (
              <Button type="primary" style={{ marginLeft: 20 }}>
                <a
                  href={`#/localMerchant/hoterCashier?title=${time}佣金打款&id=${
                    detail.id
                  }&status=${detail.status}&price=${detail.commission_fee}`}
                >
                  立即打款
                </a>
              </Button>
            )}
          </div>
        </div>
        <div
          className={styles.left}
          style={{
            paddingLeft: 40,
            borderLeft: '1px solid #e7e7e7',
            width: 282
          }}
        >
          {detail.status == 0 && (
            <Fragment>
              <p style={{ color: '#666' }}>付款链接: </p>
              <p style={{ color: '#666', marginBottom: 16 }}>
                你可将分享链接分享给财务部门
              </p>
              <img
                src={qrcode}
                className={styles.left}
                width={90}
                height={90}
              />
              <div className={styles.left} style={{ marginLeft: 16 }}>
                <p style={{ marginTop: 16 }}>
                  <a href={qrcode} target="_blank" rel="noopener noreferrer">
                    保存二维码 {'>'}
                  </a>
                </p>
                <CopyToClipboard
                  onCopy={() => message.success('已复制到剪切板！')}
                  text={
                    window.location.origin +
                    window.location.pathname +
                    '#' +
                    url
                  }
                >
                  <p style={{ marginTop: 16 }}>
                    <a>复制付款链接 {'>'}</a>
                  </p>
                </CopyToClipboard>
              </div>
            </Fragment>
          )}

          {detail.status == 1 && (
            <div style={{ textAlign: 'center', marginTop: 20 }}>
              <img src="https://qnm.hunliji.com/o_1ci43itiqomjq1hea14dk1g8ub.png" />
              <p style={{ marginTop: 15 }}>财务确认中</p>
            </div>
          )}

          {detail.status == 2 && (
            <div style={{ textAlign: 'center', marginTop: 20 }}>
              <img src="https://qnm.hunliji.com/o_1ci43itiq1q7uv001h7asul1okua.png" />
              <p style={{ marginTop: 15 }}>已打款</p>
            </div>
          )}
        </div>
      </div>
    )
  }
}
